import { render } from "./ReturnsTab.vue?vue&type=template&id=6c0afc04&scoped=true"
import script from "./ReturnsTab.vue?vue&type=script&lang=js"
export * from "./ReturnsTab.vue?vue&type=script&lang=js"

import "./ReturnsTab.vue?vue&type=style&index=0&id=6c0afc04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0afc04"]])

export default __exports__